module.exports = __webpack_public_path__ + "c8d346bf1b045143cdf588e5eb848c86.png";